import utils from "../services/utils";
let header = {
  render: async () => {
    let view = /*html*/ `
        <div id="loader" class="loader"></div>
        <div id="loader-percentage" class="loader"></div>
        <nav class="navbar navbar-light bg-light">
        <a class="navbar-brand" href="#">Playout Reporting Ops<span class="alpha">ALPHA</span></a>
        <div class="navbar-item">
          <label for="storage-account">Storage Account:&nbsp;</label>
          <select
              id="storage-account"
              onchange="localStorage.setItem('selectedStorageAccount', this.selectedIndex); window.location = '/';"
          >
              <option value="https://stlpverifyprodeu.table.core.windows.net">PROD - stlpverifyprodeu</option>
              <option value="https://stlpverifyuateu.table.core.windows.net">UAT - stlpverifyuateu</option>
              <option value="https://stlpverifycdeu.table.core.windows.net">CD - stlpverifycdeu</option>
          </select>
        </div>
        <div class="navbar-item">
          <label for="storage-account">Tenant:&nbsp;</label>
          <select
              id="tenant"
              onchange="localStorage.setItem('selectedTenant', this.selectedIndex); window.location = '/';"
          >
              <option value="Liveposter">liveposter</option>
              <option value="PML">pml</option>
              <option value="UK">uk</option>
          </select>
        </div>
        <div id="login-logout">
            <div id="logged-in">Logged in as: <span id="username">TODO</span>&nbsp;&nbsp;&nbsp;<a href="/logout">Logout</a></div>
            <div id="logged-out"><a href="/login">Login</a></div>
        </div>
        </nav>
    `;
    return view;
  },
  after_render: async () => {
    document.getElementById("storage-account").selectedIndex = localStorage.getItem("selectedStorageAccount") || 0;
    document.getElementById("tenant").selectedIndex = localStorage.getItem("selectedTenant") || 0;
    if (localStorage.getItem("access_token")) {
      let { sub: loggedInUser } = utils.parseJwt(localStorage.getItem("access_token"));
      document.getElementById("logged-in").style.display = "block";
      document.getElementById("username").innerText = loggedInUser.toLowerCase();
      document.getElementById("storage-account").style.display = "block";
      document.getElementById("logged-out").style.display = "none";
    } else {
      document.getElementById("logged-in").style.display = "none";
      document.getElementById("storage-account").style.display = "none";
      document.getElementById("logged-out").style.display = "block";
    }
  },
};

export default header;
